/** Réglages du fond Écran de veille 95 (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    ecran: {
        type: "choix", libelle: "Écran de veille", defaut: "mystify",
        options: [
            {valeur: "mystify", libelle: "Mystify : polygones qui rebondissent"},
            {valeur: "etoiles", libelle: "Ciel d'étoiles"},
            {valeur: "bulles", libelle: "Bulles (façon Windows Vista)"},
            {valeur: "aleatoire", libelle: "Au hasard (change à chaque affichage du fond)"},
        ],
    },
    vitesse: {
        type: "nombre", libelle: "Vitesse", min: 0.5, max: 3, pas: 0.1, defaut: 1, unite: "×",
        aide: "×1 est la vitesse d'origine.",
    },
    densite: {
        type: "nombre", libelle: "Densité", min: 1, max: 5, pas: 1, defaut: 3,
        aide: "Combien de choses à l'écran : polygones et traînée (Mystify), étoiles, bulles. 3 est la valeur d'origine.",
    },
};
